import React, { useContext, useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { CoolFarmOptionsContext } from '../../..'

interface FeedItemProps {
  index: number
  id: string
  herdIndex: number
  removeFeed: (index: number) => void
}

const FeedItem: React.FC<FeedItemProps> = ({ index, id, herdIndex, removeFeed }) => {
  const { t } = useTranslation()
  const { control, getValues, formState: { touchedFields }, setValue } = useFormContext()
  const options = useContext(CoolFarmOptionsContext)

  const noGrazingDays = parseInt(getValues(`herdGroups[${herdIndex}].grazingDays`) || 0) === 0
  const watchFeedId = useWatch({ control, name: `herdGroups[${herdIndex}].feeds[${index}].id` })

  const [productionRegions, setProductionRegions] = useState([])

  useEffect(() => {
    if(touchedFields?.fertilizers && touchedFields?.fertilizers[index]?.cftIngredientId){
      setValue(`fertilizers[${index}].cftProductionRegionId`, '')
    }
    const regions = productionRegionOptions(watchFeedId)
    setProductionRegions(regions)
  }, [watchFeedId])

  const productionRegionOptions = (feedId: number) => {
    const feed = options?.feeds.find(f => f.id === feedId)
    return feed?.regions?.map(region => ({
      key: region.id,
      value: region.id,
      text: region.label
    })) || []
  }

  const feedOptions = options?.feeds?.reduce((previousValue, currentValue) => {
    if(currentValue.grazingFeed === 1 && noGrazingDays) {
      return previousValue
    }
    return [...previousValue, { key: currentValue.id, value: currentValue.id, text: currentValue.label }]
  }, [])

  return (
    <Table.Row key={id}>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`herdGroups[${herdIndex}].feeds[${index}].id`}
          options={feedOptions}
          rules={{ required: true }}
          search
          placeholder={t('Select feed')}
          withoutLabel
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Select
          control={control}
          name={`herdGroups[${herdIndex}].feeds[${index}].cftFeedRegionId`}
          options={productionRegions}
          rules={{ required: true }}
          placeholder={t('Select region')}
          withoutLabel
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`herdGroups[${herdIndex}].feeds[${index}].dryMatterValue`}
          rules={{ required: true }}
          placeholder={t('Enter value')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell>
        <FormFields.Input
          control={control}
          name={`herdGroups[${herdIndex}].feeds[${index}].freshWeightValue`}
          rules={{ required: true }}
          placeholder={t('Enter value')}
          typeInput='controled'
          allowDecimals
          decimalScale={2}
          withoutAsterisk
          noErrorMessage
        />
      </Table.Cell>
      <Table.Cell textAlign='center'>
        <Icon
          name='trash'
          color='red'
          style={{ cursor: 'pointer', fontSize: '1.2em' }}
          onClick={() => removeFeed(index)}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default FeedItem
